<template>
  <apexchart v-if="data"
             type="donut"
             :options="chartOptions"
             height="250"
             :series="series"/>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: 'CT00040',
  props: ['data'],
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          type: 'donut',
          events: {
            dataPointSelection: function (event, chartContext, config) {
              this.selected(config.dataPointIndex);
            }
          }
        },
        tooltip: {
          //enabled: true
          y: {
            formatter: function (val, options) {
              let percentage = Math.round(val / options.config.series.reduce((sum, current) => sum + current, 0) * 100, 0)
              return `${Math.round(val, 3).toLocaleString('ko-KR')}  개 사 (${percentage}%)`
            },
          },
        },
        legend: {
          position: 'bottom',
        },
        dataLabels: {
          enabled: false, //=> 데이터 series값 출력
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  formatter: val => Number(val).toLocaleString('ko-KR') + '개 사'
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: '#000000',
                  formatter: chart => chart.config.series.reduce((sum, current) => sum + current, 0).toLocaleString('ko-KR') + '개 사'
                },
              },
            },
          },
        },

      },
    }
  },
  created() {

    if (this.data === 'test') {
      this.series = [8, 7, 6, 10]
      this.chartOptions.labels = ['원료 공급', '업스트림 운송', '다운스트림 운송', '기타']
    } else {
      this.chartOptions.labels = Array.from(new Set(this.data)).sort();
      this.chartOptions.labels.forEach(label => {
        this.series.push(this.data.filter(obj => obj === label).length)
      })
    }


  },
  watch: {
    data: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setSeries();
          this.setLabels();
        }
      }
    }
  },
  methods: {
    async setSeries() {
      // 시각화 데이터 추출
      this.series = this.data.map(obj => obj.values);

    },
    async setLabels() {
      // 시각화 레이블 추출
      this.chartOptions.labels = this.data.map(obj => `Scope ${obj.scope}`);
    },
  }
}
</script>
